import "./ask-axxess-banner.scss";

import { EventAggregator, Subscription } from "aurelia-event-aggregator";
import { autoinject, customElement } from "aurelia-framework";

import { AccountEvent, AuthService } from "../../services/auth-service";
import { UsersService } from "./../../services/users-service";
import { PermissionManager, PermissionEvent } from "../../common/utilities/permission-manager";
import { AdministrativePermissionEnum } from "../../enums/administrative-permission-enum";
import { PermissionActionEnum } from "../../enums/permission-action-enum";

@autoinject
@customElement("ask-axxess-banner")
export class AskAxxessBanner {
    private _ea: EventAggregator;
    private _accountChangedSubscription: Subscription;
    private _permissionSubscription: Subscription;
    private _permissionManager: PermissionManager;
    private readonly _usersService: UsersService;
    private readonly askAxxessBannerDismissedKey = "hospice-ask-axxess-banner-dismissed-account";
    public showAskAxxessBanner: boolean = false;
    public hasAskAxxessViewPermission: boolean = false;

    public constructor(usersService: UsersService, ea: EventAggregator, permissionManager: PermissionManager) {
        this._ea = ea;
        this._usersService = usersService;
        this._permissionManager = permissionManager;
        this.initSubscriptions();
    }

    public attached() {
        this.checkPerms();
        let disabled = window.localStorage.getItem(this.askAxxessBannerDismissedKey);
        if (!disabled) {
            this.handleBannerVisibility();
        }
    }

    private checkPerms() {
        this.hasAskAxxessViewPermission = this._permissionManager.checkPermission([
            { resource: AdministrativePermissionEnum.AskAxxess, action: PermissionActionEnum.View }
        ]);
    }

    private initSubscriptions() {
        this._accountChangedSubscription = this._ea.subscribe(AccountEvent.Changed, () =>
            this.handleBannerVisibility()
        );
        this._permissionSubscription = this._ea.subscribe(PermissionEvent.UserPermissionLoaded, () =>
            this.checkPerms()
        );
    }

    public async handleBannerVisibility() {
        let currentUser = await this._usersService.getCurrentUser();
        if (!currentUser.isSupportUser) {
            this.showAskAxxessBanner = true;
            window.localStorage.removeItem(this.askAxxessBannerDismissedKey);
        }
    }

    public redirectToAskAxxessPage() {
        window.location.href = this.hasAskAxxessViewPermission
            ? "/axxess-intelligence/axxess-intelligence-page"
            : "https://www.axxess.com/help/axxesshospice/axxess-intelligence/ask-axxess/";
    }

    public closeBanner() {
        this.showAskAxxessBanner = false;
        window.localStorage.setItem(this.askAxxessBannerDismissedKey, "true");
    }

    public detached() {
        this._accountChangedSubscription?.dispose();
        this._permissionSubscription?.dispose();
    }
}
